export const BenefitsDividerSVG = ({ className }: { className?: string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="42"
            viewBox="0 0 13 42"
            fill="none"
            className={className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.249769 0.0671713C0.488916 -0.0708999 0.795292 0.0106422 0.933363 0.249788L12.4334 20.1687C12.5344 20.3441 12.5157 20.5542 12.405 20.7088C12.5159 20.8634 12.5347 21.0743 12.4334 21.2498L0.933363 41.1678C0.795292 41.4069 0.488916 41.4894 0.249769 41.3514C0.010681 41.2133 -0.0709045 40.9069 0.0671522 40.6678L11.5672 20.7498C11.5755 20.7353 11.5859 20.7221 11.5955 20.7088C11.586 20.6956 11.5754 20.6831 11.5672 20.6687L0.0671522 0.749788C-0.0708352 0.510754 0.0108806 0.205326 0.249769 0.0671713Z"
                fill="#DDE8EE"
            />
        </svg>
    );
};
